import { Company } from '@/api/types/company';
import { CompanyModel } from '@/models/company';

export function transformCompany(company: Company): CompanyModel {
  return {
    name: company.name,
  };
}

export function transformCompanies(companies: Company[]): CompanyModel[] {
  return companies.map(transformCompany);
}
